"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=ISize.js.map